<template>
    <div class="tags">
        <i :class='siderHide?"el-icon-s-unfold":"el-icon-s-fold"' class="bar-switch-i" @click='siderSwtich()'></i>
        <ul style='padding-left:30px;'>
            <li class="tags-li" v-for="(item,index) in tagsList" :class="{'active': isActive(item.path)}" :key="index">
                <router-link :to="item.path" class="tags-li-title">
                    {{item.title}}
                </router-link>
                <span class="tags-li-icon" @click="closeTags(index)"><i class="el-icon-error"></i></span>
            </li>
        </ul>
        <div class="tags-close-box" style="height:30px;">
            <el-dropdown @command="handleTags">
                <el-button size="mini" type="primary">
                    标签选项<i class="el-icon-arrow-down el-icon--right"></i> 
                </el-button>
                <el-dropdown-menu size="small" slot="dropdown">
                    <el-dropdown-item command="other">关闭其他</el-dropdown-item>
                    <el-dropdown-item command="all">关闭所有</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
    import bus from './bus';
    import store from '../store/store';
    export default {
        data() {
            return {
                tagsList: [],
                siderHide:this.$store.state.siderHide
            }
        },
        methods: {
            isActive(path) {
                return path === this.$route.fullPath;
            },
            // 关闭单个标签
            closeTags(index) {
                const delItem = this.tagsList.splice(index, 1)[0];
                const item = this.tagsList[index - 1] ? this.tagsList[index - 1] : this.tagsList[index];
                console.log('item',item)
                console.log('delItem',delItem)
                if (item) {
                    this.$router.push(item.path);
                }else{
                    this.$router.push('/');
                }
            },
            // 关闭全部标签
            closeAll(){
                this.tagsList = [];
                this.$router.push('/');
            },
            // 关闭其他标签
            closeOther(){
                const curItem = this.tagsList.filter(item => {
                    return item.path === this.$route.fullPath;
                })
                this.tagsList = curItem;
            },
            // 设置标签
            setTags(route){
                // console.log(route)
                const isExist = this.tagsList.some(item => {
                    return item.path === route.fullPath;
                })
                if(!isExist){
                    if(this.tagsList.length >= 10){
                        this.tagsList.shift();
                    }
                    this.tagsList.push({
                        title: route.meta.title,
                        path: route.fullPath,
                        name: route.matched[1].components.default.name
                    })
                }
                
                // console.log(this.tagsList)
                // bus.$emit('tags', this.tagsList);
            },
            handleTags(command){
                command === 'other' ? this.closeOther() : this.closeAll();
            },
            //收起导航栏
            siderSwtich(){
                var siderHide=!this.$store.state.siderHide;
                store.commit('setSiderHide', siderHide);
            }
        },
        computed: {
            showTags() {
                return this.tagsList.length > 0;
            },
            siderHide1(){
                return this.$store.state.siderHide
            }
        },
        watch:{
            $route(newValue, oldValue){
                // console.log(newValue)
                this.setTags(newValue);
                store.commit('setRouter', newValue.name);
                sessionStorage.setItem('routePath',newValue.name);
            },
            siderHide1(newData,oldData){
                this.siderHide=newData;
            }
        },
        created(){
            this.setTags(this.$route);
            // 监听关闭当前页面的标签页
            // bus.$on('close_current_tags', () => {
            //     console.log(111)
            //     for (let i = 0, len = this.tagsList.length; i < len; i++) {
            //         const item = this.tagsList[i];
            //         if(item.path === this.$route.fullPath){
            //             if(i < len - 1){
            //                 this.$router.push(this.tagsList[i+1].path);
            //             }else if(i > 0){
            //                 this.$router.push(this.tagsList[i-1].path);
            //             }else{
            //                 this.$router.push('/');
            //             }
            //             this.tagsList.splice(i, 1);
            //             break;
            //         }
            //     }
            // })
        }
    }

</script>


<style>
    .tags {
        position: relative;
        height: 30px;
        overflow: hidden;
        background: #fff;
        padding-right: 120px;
        border-bottom:1px solid #efecec!important;
        z-index:11;
    }
    .tags ul {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
       
    }

    .tags-li {
        float: left;
        margin: 0;
        font-size: 12px;
        overflow: hidden;
        cursor: pointer;
        height: 30px;
        line-height: 30px;
        border-right:  1px solid #e5e5e5;
        background: #fff;
        padding: 0 5px 0 12px;
        vertical-align: middle;
        color: #999!important;
        -webkit-transition: all .3s ease-in;
        -moz-transition: all .3s ease-in;
        transition: all .3s ease-in;
    }
    .tags-li-icon .el-icon-error{color:#ccc!important;}
    .tags-li:hover {
        background:rgb(243, 244, 245);
    }

    .tags-li.active {
        
        background: rgb(243, 244, 245);
    }
    .router-link-active{
        color: #23508e!important;
    }
    .tags-li-title {
        float: left;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-right: 5px;
        color: #999;
    }

    .tags-li.active .tags-li-title {
        color: #999;
    }

    .tags-close-box {
        position: absolute;
        right: 0;
        top: 0;
        box-sizing: border-box;
        text-align: center;
        width: 105px;
        height: 30px;
        background: #fff;
        z-index: 10;
    }
    .bar-switch-i{font-size:18px;color:#999;float:left;padding:9px 10px;cursor: pointer;border-right:1px solid #e5e5e5;}
</style>



// WEBPACK FOOTER //
// src/components/Tags.vue